"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotEnoughParametersError = void 0;
var tslib_1 = require("tslib");
var NotEnoughParametersError = /** @class */ (function (_super) {
    tslib_1.__extends(NotEnoughParametersError, _super);
    function NotEnoughParametersError(_command, _expectedParams, _actualParams) {
        var _this = _super.call(this, "command \"" + _command + "\" expected " + _expectedParams + " or more parameters, got " + _actualParams) || this;
        _this._command = _command;
        _this._expectedParams = _expectedParams;
        _this._actualParams = _actualParams;
        Object.setPrototypeOf(_this, NotEnoughParametersError.prototype);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, NotEnoughParametersError);
        }
        return _this;
    }
    Object.defineProperty(NotEnoughParametersError.prototype, "command", {
        get: function () {
            return this._command;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotEnoughParametersError.prototype, "expectedParams", {
        get: function () {
            return this._expectedParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotEnoughParametersError.prototype, "actualParams", {
        get: function () {
            return this._actualParams;
        },
        enumerable: false,
        configurable: true
    });
    return NotEnoughParametersError;
}(Error));
exports.NotEnoughParametersError = NotEnoughParametersError;
